import { Platform } from 'react-native';

export const styles = {
  option: 'flex-row justify-between px-lg py-md hover:bg-neutral10 gap-sm',
  optionsContainer:
    'mx-md mb-xl rounded-md bg-neutral10 shadow-resting-neutral10 overflow-hidden',
  optionIndicator: 'w-md justify-center',
  bottomSheet: `${Platform.OS === 'web' ? 'fixed' : 'absolute'} bottom-0 left-0 right-0 top-0  overflow-hidden`,
  trigger: 'absolute bottom-0 left-0 right-0 top-0',
  footer: 'border-t border-neutral20 p-lg',
  header: 'px-md py-lg',
  handle:
    'absolute top-sm left-1/2 -translate-x-1/2 h-xs w-[6.4rem] bg-neutral40 rounded-md',
};
